import Flag from "react-world-flags";

import CountryData = App.Data.CountryData;

interface CountryFlagProps {
    country: CountryData;
    className?: string;
}

export const CountryFlag = ({ country, className }: CountryFlagProps) => {
    if (!country) {
        return null;
    }
    return <Flag code={country.iso3} className={`h-[13px] rounded-[3px] ${className ?? ""}`} />;
};
